import moment from 'moment';
import {
  EnterpriseBroadcastFormGeneratorFilter,
  EnterpriseBroadcastFormGeneratorModelEdit,
  ENTERPRISE_GENERATOR_FILTER_FIELDS,
} from 'types/BroadcastForm';

const numberRegex = /^[0-9]+$/;

export function filterFieldLabelForError(filterField: string): string {
  if (
    filterField.toLowerCase()
    === ENTERPRISE_GENERATOR_FILTER_FIELDS.SERVICE_LEVEL_ON_RELATED_RESIDENT.toLowerCase()
  ) {
    return 'Service level (on related resident)';
  }
  return filterField.includes('#')
    ? filterField.split('#')[0].trim()
    : filterField;
}

export function hasCommaSeparatedTokens(value: string | null | undefined): boolean {
  if (value == null || value === '') return false;
  return value.split(',').some((s) => s.trim() !== '');
}

export function shouldWarnBothServiceLevelFilters(
  filters: EnterpriseBroadcastFormGeneratorFilter[] | undefined,
): boolean {
  if (!filters?.length) return false;
  let hasResidentServiceLevel = false;
  let hasRelatedResidentServiceLevel = false;
  filters.forEach((f) => {
    const field = f.FilterField.toLowerCase();
    if (field === ENTERPRISE_GENERATOR_FILTER_FIELDS.SERVICE_LEVEL_V1SYNC.toLowerCase()) {
      hasResidentServiceLevel = true;
    }
    if (field === ENTERPRISE_GENERATOR_FILTER_FIELDS.SERVICE_LEVEL_ON_RELATED_RESIDENT.toLowerCase()) {
      hasRelatedResidentServiceLevel = true;
    }
  });
  return hasResidentServiceLevel && hasRelatedResidentServiceLevel;
}

export const BOTH_SERVICE_LEVEL_FILTERS_WARNING = (
  'Both Service Level and Service level (on related resident) filters are in use. '
  + 'Service Level applies to the profile being evaluated (typically residents). '
  + 'Service level (on related resident) applies only to family recipients. '
  + 'Using both on one generator can exclude everyone—use separate generators when you need different audience filtering.'
);

/**
 * Client-side validation aligned with EnterpriseBroadcastFormService.ValidateGenerator.
 */
export function validateEbfGeneratorFilters(
  formData: EnterpriseBroadcastFormGeneratorModelEdit,
): string | null {
  const fdFilters = formData.Filters;
  let filterError = '';
  const includeFilterFields: string[] = [];

  fdFilters?.forEach((filter) => {
    if (filter.FilterType.toLocaleLowerCase() === 'include') {
      if (includeFilterFields.indexOf(filter.FilterField) >= 0) {
        filterError = `Filter Field ${filterFieldLabelForError(filter.FilterField)} can not occur multiple times in Include filter.`;
      } else {
        includeFilterFields.push(filter.FilterField);
      }
    }

    const fieldLower = filter.FilterField.toLowerCase();

    if (fieldLower === 'start date#v1sync' || fieldLower === 'end date#v1sync') {
      if (!filter.FilterStartDate && !filter.FilterEndDate) {
        filterError = 'The "After" and "Before" values must have at least one value provided.';
      }
      if (filter.FilterStartDate && filter.FilterEndDate) {
        if (moment(filter.FilterEndDate) <= moment(filter.FilterStartDate)) {
          filterError = 'The value of After must be earlier than the value of Before.';
        }
      }
    } else if (
      fieldLower
        === ENTERPRISE_GENERATOR_FILTER_FIELDS.SERVICE_LEVEL_ON_RELATED_RESIDENT.toLowerCase()
        && !formData.SendToFamily
    ) {
      filterError = 'Service level (on related resident) requires Send to Family to be enabled.';
    } else if (!hasCommaSeparatedTokens(filter.FilterValue)) {
      filterError = 'The Filter Value is required.';
    } else if (fieldLower === 'account id') {
      const accountFilters = filter.FilterValue.split(',');
      accountFilters.forEach((af) => {
        if (!numberRegex.test(af.trim())) {
          filterError = 'The Account Id must be a number.';
        }
      });
    }
  });

  return filterError || null;
}
